import {useCallback} from 'react';

import notifications from 'notifications';
import {RealtimeMessageType} from 'realtime/Constants';
import {RealtimeMessage} from 'realtime/RealtimeChannel';
import useRealtimeChannelSubscription from 'realtime/useRealtimeChannelSubscription';
import {getRealtimeChannelNameForApiId} from 'realtime/util/RealtimeUtil';

/**
 * Hook to listen for worksheet realtime notifications and display toasts.
 *
 * Currently handles:
 * - WORKSHEET_STEP_REOPENED: Shows a toast when a step is reopened due to cross-step data references
 *
 * @param worksheetId - The ID of the worksheet to listen for notifications on
 */
export function useWorksheetRealtimeNotifications(worksheetId: string): void {
  const onMessage = useCallback((message: RealtimeMessage) => {
    if (message.name === RealtimeMessageType.WORKSHEET_STEP_REOPENED) {
      const {stepName} = message.data;
      notifications.warn(`Your change updated values and reopened "${stepName}"`);
    }
  }, []);

  useRealtimeChannelSubscription(getRealtimeChannelNameForApiId(worksheetId), onMessage, [
    RealtimeMessageType.WORKSHEET_STEP_REOPENED,
  ]);
}
